<script>
    import ContentSection from "../../../common/ContentSection.svelte";
    import GeneralLayout from "../../../common/GeneralLayout.svelte";
    import HeaderBar from "../../../components/header/HeaderBar.svelte";
    import SaaltextSlider from "../components/SaaltextSlider.svelte";
    import { _ } from "svelte-i18n";
    import { getEntity } from "../../../api-client";
    import LoadingSquare from "../../../common/LoadingSquare.svelte";

    export let params = {};
    $: if (params.id) {
        window.scrollTo(0, 0);
    }
    let saalheftId = params.id;
    let saalheft = getEntity("saalheft", saalheftId).then(async (result) => {
        saalheft = result;
        saalheft.saals = [];

        for (const fk of saalheft.fk_saaltexte) {
            const saaltext = await getEntity("saaltext", fk);
            saalheft.saals = [...saalheft.saals, saaltext];
        }
        return saalheft;
    });
</script>

{#await saalheft}
    <LoadingSquare />
{:then saalheft}
    <!-- Header Bar -->
    <div class="display-small">
        <HeaderBar title={saalheft.name} />
    </div>
    <GeneralLayout>
        <div slot="firstSegment">
            <div class="display-big">
                <HeaderBar hideSeperator />
            </div>
            <div class="header">
                <div class="headline-xs saalheft-title">{saalheft.name}</div>
                <div class="headline-l">{$_("exhibition_texts_title")}</div>
            </div>
        </div>
        <div slot="secondSegment" class="second-segment">
            <!-- Slider fuer Saaltexte -->
            <SaaltextSlider saals={saalheft.saals} {saalheftId} />

            <div class="padding">
                <div class="divider-h  divider" />

                <!-- Text Sections -->
                {#each saalheft.sections as section}
                    <div class="text-section">
                        <ContentSection title={section.header}>
                            <div slot="content">
                                <div class="text-l">
                                    {@html section.content}
                                </div>
                            </div>
                        </ContentSection>
                    </div>
                    {#if section.index !== saalheft.sections[saalheft.sections.length - 1].index}
                        <div class="divider-h  divider" />
                    {/if}
                {/each}
            </div>
        </div>
    </GeneralLayout>
{:catch}
    <div class="error">
        <span class="text-l" style="font-size: 24px;">
            {$_("entity_load_error")}
        </span>
    </div>
{/await}

<style>
    .padding {
        padding: 0 16px;
    }

    .header {
        margin-bottom: 32px;
        padding: 0 16px;
    }

    .divider {
        margin: 8px 0;
    }

    .text-section {
        padding: 8px 0;
    }

    .saalheft-title {
        margin-bottom: 8px;
    }

    @media only screen and (min-width: 1440px) {
        .headline-xs {
            font-size: 24px;
            line-height: 100%;
        }

        .headline-l {
            font-size: 64px;
            line-height: 100%;
        }

        .divider {
            margin: 16px 0;
        }

        .text-section {
            padding: 32px 0;
        }

        .second-segment {
            padding-top: 56px;
        }

        .padding {
            padding: 0 40px 0 24px;
        }
    }
</style>
